import { useMemo } from "react";

export const parseSchedule = ({
  schedule,
  hasEndDate,
}: {
  schedule?: string;
  hasEndDate?: boolean;
}) => {
  let scheduleType:
    | "weeks"
    | "months"
    | "someMonths"
    | "startAndFinish"
    | "onetime";
  let dayOfMonthOption: "first" | "last" | "custom";
  let minute: string;
  let hour: string;
  let month: string;
  let dayOfWeek: string;
  let daysOfMonth: string[];
  let months: string[];

  let match: RegExpMatchArray;

  if (schedule) {
    const scheduleParts = schedule.split(" ");

    minute = scheduleParts[0];
    hour = scheduleParts[1];

    if ((match = scheduleParts[4].match(/^([0-9]+)$/))) {
      scheduleType = "weeks";
      dayOfWeek = match[1];
    } else if (
      scheduleParts[3] === "*" ||
      (match = scheduleParts[3].match(/^\d+(,\d+)*$/))
    ) {
      if (match) {
        scheduleType = "someMonths";
        months = scheduleParts[3].split(",");
      } else {
        scheduleType = "months";
      }

      if (scheduleParts[2] === "1") {
        dayOfMonthOption = "first";
      } else if (scheduleParts[2] === "L") {
        dayOfMonthOption = "last";
      } else {
        dayOfMonthOption = "custom";
        daysOfMonth = scheduleParts[2].split(",");
      }
    }
  } else if (hasEndDate) {
    scheduleType = "startAndFinish";
  } else {
    scheduleType = "onetime";
  }

  return {
    scheduleType,
    dayOfMonthOption,
    minute,
    hour,
    month,
    dayOfWeek,
    daysOfMonth,
    months,
  };
};

const useSchedule = ({
  schedule,
  hasEndDate,
}: {
  schedule?: string;
  hasEndDate: boolean;
}) => {
  const parsedSchedule = useMemo(
    () => parseSchedule({ schedule, hasEndDate }),
    [schedule, hasEndDate]
  );

  return parsedSchedule;
};

export default useSchedule;
